import { createAction, createSlice } from "@reduxjs/toolkit";

export const archiveWorkflowRequest = createAction("workflowArchive/archiveWorkflowRequest");

const initialState = {
  response: null,
  loading: false,
  error: null
};

const workflowArchiveSlice = createSlice({
  name: "workflowArchive",
  initialState,
  reducers: {
    archiveWorkflowStart(state) {
      state.loading = true;
      state.error = null;
    },
    archiveWorkflowSuccess(state, action) {
      state.loading = false;
      state.response = action.payload || null;
      state.error = null;
    },
    archiveWorkflowFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearWorkflowArchiveState(state) {
      state.response = null;
      state.loading = false;
      state.error = null;
    }
  }
});

export const {
  archiveWorkflowStart,
  archiveWorkflowSuccess,
  archiveWorkflowFailure,
  clearWorkflowArchiveState
} = workflowArchiveSlice.actions;

export default workflowArchiveSlice.reducer;
